import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import GraphArc from '../../Common/GraphArc/GraphArc';
import Card from '../../Common/Card';
import Icon from '../../Common/Icon';
import ReactCardFlip from 'react-card-flip';
import Moment from 'moment';
import { DATE_FORMAT, TASK_LIST_MENU_ITEMS, EVENT_DATE_FORMAT } from '../../../constants/constants';
import { actions as locationTaskActions } from '../../../actions/locationTaskActions';

export class LocationSummaryGraph extends Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			isFlipped: false,
		};

		this.frontCardRef = React.createRef();
		this.backCardRef = React.createRef();
	}

	flipCard = () => {
		this.setState((prevState) => ({ isFlipped: !prevState.isFlipped }));
	};

	onTitleClick = () => {
		const urlParams = {
			locationKeys: this.props.totalUrlParams.LocationKeys,
		};
		this.props.onTitleClick(urlParams);
	};

	renderDayDiff = () => {
		const openingDate = Moment.utc(this.props.openingDate);
		const diff = openingDate.diff(Moment.utc(), 'days');

		if (diff === 0) {
			return 'Opening Today!';
		} else if (diff < 0) {
			return `Opened ${diff * -1} days ago`;
		} else if (diff > 0) {
			return `Opening in ${diff + 1} days`;
		}
	};

	render() {
		return (
			<ReactCardFlip isFlipped={this.state.isFlipped} flipDirection='horizontal'>
				{/* Front Card */}
				<Card key='front' className='card' ref={this.frontCardRef}>
					<GraphArc
						title={this.props.locationName}
						data={this.props.data}
						totalUrlParams={this.props.totalUrlParams}
						onClick={this.props.onClick}
						onTitleClick={this.onTitleClick}
					/>
					<div className='info text-end' onClick={this.flipCard}>
						<Icon name='info-circle' />
					</div>
				</Card>

				{/* Back Card */}
				<Card key='back' className='card bg-light' ref={this.backCardRef}>
					<p className='card-text mb-0'>
						Open Date: {Moment.utc(this.props.openingDate).format(DATE_FORMAT)} ({this.renderDayDiff()})
					</p>
					<p className='card-text mb-1'>Mgmt Co: {this.props.managementCompany}</p>

					<p className='card-text fw-bold mb-0'>Quick Links</p>
					<div className='d-flex flex-column align-items-start'>
						<a
							href={`/tasks?l=${this.props.locationKey}&tde=${Moment.utc()
								.subtract(1, 'days')
								.format(EVENT_DATE_FORMAT)}&m=true&${this.props.upcomingTasksDueIds
								.map((id) => `s=${id}`)
								.join('&')}&ddo=pastDueTasks`}
							className='text-decoration-none'>
							Past Due Milestones
						</a>
						<a
							href={`/tasks?l=${this.props.locationKey}&tde=${Moment.utc()
								.subtract(1, 'days')
								.format(EVENT_DATE_FORMAT)}&${this.props.upcomingTasksDueIds.map((id) => `s=${id}`).join('&')}&ddo=pastDueTasks`}
							className='text-decoration-none'>
							Past Due Tasks
						</a>
						<a
							href={`/tasks?l=${this.props.locationKey}&tds=${Moment.utc().format(EVENT_DATE_FORMAT)}&tde=${Moment.utc()
								.add(10, 'days')
								.format(EVENT_DATE_FORMAT)}&${this.props.upcomingTasksDueIds.map((id) => `s=${id}`).join('&')}&ddo=dueSoonTasks`}
							className='text-decoration-none'>
							Upcoming Tasks Due
						</a>
					</div>

					<div className='position-relative mt-3'>
						<p className='card-subtitle fw-semibold text-center mb-0'>{this.props.locationName}</p>
						<div className='position-absolute top-0 end-0' onClick={this.flipCard} style={{ cursor: 'pointer' }}>
							<Icon name='times' />
						</div>
					</div>
				</Card>
			</ReactCardFlip>
		);
	}
}

LocationSummaryGraph.propTypes = {
	locationName: PropTypes.string.isRequired,
	locationKey: PropTypes.string.isRequired,
	managementCompany: PropTypes.string,
	openingDate: PropTypes.string,
	data: PropTypes.array.isRequired,
	totalUrlParams: PropTypes.object.isRequired,
	onClick: PropTypes.func.isRequired,
	onTitleClick: PropTypes.func.isRequired,
	upcomingTasksDueIds: PropTypes.array.isRequired,
	locationTaskActions: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => ({
	locationTaskActions: bindActionCreators({ ...locationTaskActions }, dispatch),
});

export default connect(null, mapDispatchToProps)(LocationSummaryGraph);
